module.exports = __webpack_public_path__ + "static/doodles-0715e972a3efed46ccb73258eaab62a6.jpg";